<div class="PageContent">
 
    <div class="overlay" *ngIf="ShowAddNewPartnerForm || ShowNewProfitSettings;"></div>
    <div class="overlayTransparent animated fadeIn" *ngIf="ShowFilter == true || this.loadingGallery == true;" (click)="CloseOverlay();"></div>
  
    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProfitMessage">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteProfitMessage = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProfitMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProfitMessage = false; DeleteProfitSettings();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>
  
    <div class="NewProfitSettingsContainer animated fadeInDown" *ngIf="ShowNewProfitSettings == true;">
      <div class="NewProfitSettingsContainerTitle">{{'AddNewProfitSettings' | translate}}</div>
      <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewProfitSettings = false;">
        <i class="material-icons">close</i>
      </div>
  
      <div class="NewProfitSettingsContainerBody">
  
        <div class="NewProfitSettingsContainerBodyRow">
          <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
            <mat-label>{{'ChoosePartner' | translate}}*</mat-label>
            <input class="BrandSelect"
                   type="text"
                   placeholder="{{'ChoosePartner' | translate}}"
                   matInput
                   [matAutocomplete]="auto2"
                   [(ngModel)]="this.ProfitSettings.PartnerName"
                   (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                   (click)="InitializePartners();">
            <i class="material-icons BrandSelectCloseIcon" *ngIf="this.ProfitSettings?.PartnerID?.length > 0;" (click)="ClearPartnerFromProfitSettings();">close</i>
            <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.ProfitSettings?.PartnerID?.length > 0) != true;">search</i>
            <mat-autocomplete #auto2="matAutocomplete">
              <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.ProfitSettings.PartnerID = p.ID; this.ProfitSettings.PartnerName = p.Name;">
                {{p.Name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
         </div>
  
         <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.PercentageImpact?.PercentageProfitMargin != null">
          <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
            <mat-label>% {{ 'OurProfit' | translate }}*</mat-label>
            <input disabled="true" matInput placeholder="{{ 'OurProfit' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.PercentageImpact.PercentageProfitMargin">
          </mat-form-field>
         </div>
  
         <div class="NewProfitSettingsContainerBodyRow">
          <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
            <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
            <input class="BrandSelect"
                   type="text"
                   placeholder="{{'SearchConfiguration' | translate}}"
                   matInput
                   (click)="InitializeImportConfigurations();"
                   [matAutocomplete]="auto3"
                   [(ngModel)]="this.ProfitSettings.ImportConfigurationName"
                   (ngModelChange)="this.configSearchTermUpdate.next($event)">
            <i style="height: 25px; line-height:25px;" class="material-icons BrandSelectCloseIcon">search</i>
            <mat-autocomplete #auto3="matAutocomplete">
              <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="this.ProfitSettings.ImportConfiguration = c; this.ProfitSettings.ImportConfigurationName = c.Name; this.GetImportConfigurationDetails(c);">
                {{c.Name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
         </div>
  
         <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.ImportConfiguration?.DiscountedGroups?.length > 0;">
          <mat-form-field appearance="outline"class="ProductPropertyTextBox" style="margin-left: 5%;">
            <mat-label>{{ 'SearchGroup' | translate }}</mat-label>
            <mat-select name="SearchGroup" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ProfitSettings.DiscountGroup">
              <mat-option *ngFor="let g of this.ProfitSettings?.ImportConfiguration?.DiscountedGroups" [value]="g">
                {{g.GroupName}} ({{g.DiscountValue}}% {{'PurchaseDiscount' | translate}})
              </mat-option>
            </mat-select>
          </mat-form-field>
         </div>
  
       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
          <mat-label>{{'SelectBrand' | translate}}</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 matInput
                 [matAutocomplete]="auto9"
                 [(ngModel)]="this.ProfitSettings.BrandName"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
          <mat-autocomplete #auto9="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.ProfitSettings.Brand = brand; this.ProfitSettings.BrandName = brand.Name;">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
       </div>
  
       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline"class="ProductPropertyTextBox" style="margin-left: 5%;" matTooltip="{{this.ProfitSettings?.PercentageImpact?.Description}}" matTooltipClass='neutral-tool-tip-management'>
          <mat-label>{{ 'ProfitSettingsPercentageImpact' | translate }}</mat-label>
          <mat-select name="ProfitSettingsPercentageImpact" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ProfitSettings.PercentageImpact">
            <mat-option *ngFor="let p of this.ProfitSettingsPercentageImpacts" [value]="p">
              {{p.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
       </div>
  
       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
          <mat-label *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 0;">{{ 'PriceListDiscountClient' | translate }}*</mat-label>
          <mat-label *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 1;">{{ 'PureProfitFromPurchasePrice' | translate }}*</mat-label>
          <input matInput placeholder="{{ 'Percentage' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.Percentage">
        </mat-form-field>
       </div>
  
       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
          <mat-label>{{ 'ExtraAddedValue' | translate }}*</mat-label>
          <input matInput placeholder="{{ 'ExtraAddedValue' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.ExtraAddedValue">
        </mat-form-field>
       </div>
  
       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
          <mat-label>{{ 'ExtraAddedPercentageValue' | translate }}*</mat-label>
          <input matInput placeholder="{{ 'ExtraAddedPercentageValue' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.ExtraAddedPercentageValue">
        </mat-form-field>
       </div>
      </div>
  
      <div class="NewProfitSettingsContainerCommands">
        <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="AddUpdatePartnerProfitSettings();">
          <span>{{'SaveButton' | translate}}</span>
          <i class="material-icons">save_alt</i>
        </button>
  
        <button mat-raised-button color="warn" style="background: #fd4f57;" class="SaveProfitSettingsButton" (click)="this.ShowDeleteProfitMessage = true;">
          <span>{{'Delete' | translate}}</span>
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
  
    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowPartnerAgentDeleteMessage">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowPartnerAgentDeleteMessage = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowPartnerAgentDeleteMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowPartnerAgentDeleteMessage = false; DeletePartnerAgent(this.PartnerAgent.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>
  
    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowPartnerAddressDeleteMessage">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowPartnerAddressDeleteMessage = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowPartnerAddressDeleteMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowPartnerAddressDeleteMessage = false; DeletePartnerShippingAddress(this.CurrentShippingAddress);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>
  
    <div class="NewProductContainer animated fadeInDown" *ngIf="ShowAddNewPartnerForm == true;">
      <div class="NewProductContainerTitleBar">
        <p *ngIf="this.Partner.ID ==  null;">{{'AddNewPartner' | translate}}</p>
        <p *ngIf="this.Partner.ID?.length > 0;">{{'ModifyPartner' | translate}}: {{this.Partner.Name}}</p>
        <i class="material-icons" (click)="ShowAddNewPartnerForm = false;">close</i>
      </div>
      <div class="NewProductContainerBody">
  
        <div *ngIf="ShowBillingInfo" class="fullWidth">
          <div class="TwoThirdsColumn" style="width: 50%;">
  
            <div class="ColumnTitle">
              <i class="material-icons">radio_button_checked</i>
              {{'GeneralInformation' | translate}}
            </div>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Name' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Name">
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'VAT' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'VAT' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.VAT">
            </mat-form-field>
    
            <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.TaxPayer">{{'TaxPayer' | translate}}</mat-slide-toggle>
            </div>
    
            <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
              <button mat-raised-button class="EUVATVIESButton" (click)="GetPartnerEUData(this.Partner);">
                {{'VerifyEUVATVIES' | translate}}
                <i class="material-icons VatViesIcon" *ngIf="this.Partner.EUVATVerified"  matTooltip="{{ 'EUVATVerifiedDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>verified_user</i>
                <i class="material-icons VatViesIcon" *ngIf="!this.Partner.EUVATVerified" style="color: red;">verified_user</i>
              </button>
            </div>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'UPN' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'UPN' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.UPN">
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'COCRegNumber' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'COCRegNumber' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.COCRegNumber">
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'EventRegister' | translate }}*</mat-label>
              <input disabled="true" matInput placeholder="{{ 'EventRegister' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.RegisteredUI">
            </mat-form-field>
         
            <div class="ColumnTitle">
              <i class="material-icons">location_on</i>
              {{'BillingAddress' | translate}}
            </div>
    
            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <mat-label>{{ 'Country' | translate }}</mat-label>
              <mat-select name="Country" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.BillingAddress.Country">
                <mat-option *ngFor="let c of this.Countries" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'StateProvince' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'StateProvince' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.StateProvince">
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'City' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'City' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.City">
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Address' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Address' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.AddressLine">
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'ZipCode' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'ZipCode' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.ZipCode">
            </mat-form-field>   
          </div>
          <div class="OneThirdColumn" style="width: 50%;">
            <div class="ColumnTitle">
              <i class="material-icons">attach_money</i>
              {{'Partners.PartnerWindow.Bank' | translate}}
            </div>
    
            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Bank' | translate }}</mat-label>
              <mat-select name="Partners.PartnerWindow.Bank" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.Bank">
                <mat-option *ngFor="let b of this.Banks" [value]="b" (click)="SwitchPartnerBank(b);">
                  {{b.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Bank' | translate }}*</mat-label>
              <input disabled="true" matInput placeholder="{{ 'Partners.PartnerWindow.Bank' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Bank.Name">
            </mat-form-field> 
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Swift' | translate }}*</mat-label>
              <input disabled="true" matInput placeholder="{{ 'Swift' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Bank.Swift">
            </mat-form-field> 
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Bank.BankAccount">
            </mat-form-field> 
    
            <div class="ColumnTitle" style="margin-top: 45px;margin-bottom: 20px;">
              <i class="material-icons">account_circle</i>
              {{'Partners.PartnerWindow.ContactInfo' | translate}}
            </div>
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Email">
            </mat-form-field> 
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.ContactInfo' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Partners.PartnerWindow.Name' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Name">
            </mat-form-field> 
    
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Login.Phone' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Phone">
            </mat-form-field> 
    
          </div>
        </div>
  
        <div *ngIf="ShowShippingInfo" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
          <div class="ColumnTitle">
            <i class="material-icons">flight</i>
            {{'ShippingAddresses' | translate}}
          </div>
  
          <div class="fullWidth">
            <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" (click)="GenerateInitialShippingAddress();">
              <i class="material-icons">add</i>
              {{'GenerateInitialShippingAddress' | translate}}
            </button>
  
            <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top: 25px; width: 95%;">
              <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
              <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentShippingAddress">
                <mat-option *ngFor="let a of this.Partner.ShippingAddresses" [value]="a">
                  {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <div class="halfWidth" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top:20px;">
  
            <div class="ColumnTitle" style="margin-bottom: 20px;">
              <i class="material-icons">edit_location</i>
              {{'AddressDetails' | translate}}
            </div>
  
            <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.CurrentShippingAddress.ActiveAddress">
                <span *ngIf="this.CurrentShippingAddress.ActiveAddress == true;">{{'ActiveAddress' | translate}}</span>
                <span *ngIf="this.CurrentShippingAddress.ActiveAddress != true;">{{'DisabledAddress' | translate}}</span>
              </mat-slide-toggle>
            </div>
  
            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <mat-label>{{ 'Country' | translate }}</mat-label>
              <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentShippingAddress.Country">
                <mat-option *ngFor="let c of this.Countries" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'StateProvince' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'StateProvince' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.State">
            </mat-form-field> 
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Partners.PartnerWindow.City' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.City">
            </mat-form-field> 
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Partners.PartnerWindow.AddressLine' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.AddressLine">
            </mat-form-field> 
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'ZipCode' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'ZipCode' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ZipCode">
            </mat-form-field> 
  
            <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.CurrentShippingAddress.IsSelected">{{'MainAddress' | translate}}</mat-slide-toggle>
            </div>
  
            <button mat-raised-button color="warn" class="DeleteAddressButton" style="margin-left: 0px;" (click)="ShowPartnerAddressDeleteMessage = true;">
              <i class="material-icons">close</i>
              {{'DeleteButton' | translate}}
            </button>
  
          </div>
  
          <div class="halfWidth" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top:20px;">
            <div class="ColumnTitle" style="margin-bottom: 62px;">
              <i class="material-icons">account_circle</i>
              {{'Partners.PartnerWindow.ContactInfo' | translate}}
            </div>
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.ContactInfo' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Partners.PartnerWindow.ContactInfo' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ContactPerson">
            </mat-form-field> 
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Company' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Company' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ContactCompany">
            </mat-form-field> 
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Email' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Email' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.Email">
            </mat-form-field> 
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Login.Phone' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.Phone">
            </mat-form-field> 
  
            <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" (click)="AddUpdateShippingAddress(this.CurrentShippingAddress, this.Partner.ID);">
              <i class="material-icons">save_alt</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>
  
        <div *ngIf="ShowAgentsInfo" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
          <div class="ColumnTitle">
            <i class="material-icons">flight</i>
            {{'AgentsInfo' | translate}}
          </div>
  
          <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.PartnerAgents?.length > 0;" style="margin-top: 25px; width: 95%;">
            <mat-label>{{ 'Agents' | translate }}</mat-label>
            <mat-select name="PartnerAgents" [compareWith]="this.parent.compareFn" [(ngModel)]="this.PartnerAgent">
              <mat-option *ngFor="let p of this.PartnerAgents" [value]="p">
                {{p.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <div class="fullWidth">
            <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" (click)="InitializePartnerAgent(this.Partner.ID);">
              <i class="material-icons">add</i>
              {{'AddNewAgent' | translate}}
            </button>
  
           <div *ngIf="this.PartnerAgent != null;">
            <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.ShippingAddresses?.length > 0;" style="margin-top: 25px; width: 95%;">
              <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
              <mat-select name="PartnerAgentAllocatedShippingAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.PartnerAgent.AllocatedShippingAddress">
                <mat-option *ngFor="let a of this.ShippingAddresses" [value]="a">
                  {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <div class="halfWidth">
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'Name' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.PartnerAgent.Name">
              </mat-form-field> 
  
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'Phone' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'Phone' | translate }}*" autocomplete="off" [(ngModel)]="this.PartnerAgent.Phone">
              </mat-form-field> 
  
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'Email' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'Email' | translate }}*" autocomplete="off" [(ngModel)]="this.PartnerAgent.Email">
              </mat-form-field> 
           
              <button mat-raised-button color="warn" class="DeleteAddressButton" style="margin-left: 0px;" (click)="ShowPartnerAgentDeleteMessage = true;">
                <i class="material-icons">close</i>
                {{'DeleteButton' | translate}}
              </button>
  
            </div>
  
            <div class="halfWidth">
              <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.Departments?.length > 0;">
                <mat-label>{{ 'Department' | translate }}</mat-label>
                <mat-select name="AgentsDepartments" [compareWith]="this.parent.compareFn" [(ngModel)]="this.PartnerAgent.Department">
                  <mat-option *ngFor="let d of this.Departments" [value]="d">
                    {{d.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" *ngIf="PartnerAgent != null;" (click)="AddUpdatePartnerAgent();">
                <i class="material-icons">save_alt</i>
                {{'SaveButton' | translate}}
              </button>
            </div>
           </div>
          </div>
        </div>
  
        <div *ngIf="ShowProfitSettings" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
          <div class="ColumnTitle">
            <i class="material-icons" style=" font-size: 30px;">monetization_on</i>
            {{'ProfitSettings' | translate}}
          </div>
  
          <div class="ColumnTitle">
            <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
            <span matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>Important</span>
          </div>
  
          <div class="fullWidth">
  
            <div class="ProfitSettingsTable">
              <button mat-raised-button color="primary" class="AddNewProfitButton" (click)="OpenNewProfitSettings();">
                <i class="material-icons">add</i>
                <span>{{'AddNewProfitSettings' | translate}}</span>
              </button>
            </div>
  
            <div class="ProfitSettingsTable">
              <div class="ProfitSettingsRow ProfitSettingsHeadder">
                <div class="ProfitSettingsCol" style="width: 5%;">
                  <span>#</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 20%;">
                  <span>{{'Client' | translate}}</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;">
                  <span>{{'DiscountGroup' | translate}}</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;">
                  <span>{{'ImportConfiguration' | translate}}</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;">
                  <span>{{'Brand' | translate}}</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;">
                  <span>{{'Percentage' | translate}}</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 10%;">
                  <span>{{'Profit' | translate}}</span>
                </div>
  
                <div class="ProfitSettingsCol" style="width: 5%;">
                  <span>{{'Actions' | translate}}</span>
                </div>
              </div>
    
              <div class="ProfitSettingsRow" *ngFor="let ps of this.Partner?.PartnerProfitSettings; let i=index;">
                <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                  <span>{{i + 1}}</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 20%;" (click)="EditProfitSettings(ps);">
                  <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                  <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">-----</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                  <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                  <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                  <span *ngIf="ps.DiscountGroup == null;">-----</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                  <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                  <span *ngIf="ps.ImportConfiguration == null;">-----</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                  <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                  <span *ngIf="ps.Brand == null;">-----</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                  <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                  <span *ngIf="ps.Percentage == null;">-----</span>
                </div>
    
                <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                  <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                  <span *ngIf="ps.PercentageImpact == null;">-----</span>
                </div>
  
                <div class="ProfitSettingsCol" style="width: 5%;" (click)="CopyProfitSettingsUI(ps);">
                  <i class="material-icons">content_copy</i>
                </div>
              </div>
    
            </div>
          </div>
         
        </div>
  
        <div *ngIf="ShowProcessingSettings" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
          <div class="ColumnTitle">
            <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'ProcessingSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
            <span>{{'ProcessingSettings' | translate}}</span>
          </div>
  
          <div class="fullWidth">
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.NotifiesWithAttachments" matTooltip="{{ 'NotifiesWithAttachmentsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'NotifiesWithAttachments' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.AutoPrinting" matTooltip="{{ 'AutoPrintingDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'AutoPrinting' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.AllocateAutomaticShippingCost" matTooltip="{{ 'AllocateAutomaticShippingCostDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'AllocateAutomaticShippingCost' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.GenerateInvoice" matTooltip="{{ 'GenerateInvoiceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'GenerateInvoice' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.GenerateTrackingLabel" matTooltip="{{ 'GenerateTrackingLabelDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'GenerateTrackingLabel' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SeparateOrderInvoices" matTooltip="{{ 'SeparateOrderInvoicesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SeparateOrderInvoices' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SplitShippingCostOnAllInvoices" matTooltip="{{ 'SplitShippingCostOnAllInvoicesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SplitShippingCostOnAllInvoices' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.GenerateQWCertificate" matTooltip="{{ 'GenerateQWCertificateDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'GenerateQWCertificate' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.PrintOnlyDeliveryNote" matTooltip="{{ 'PrintOnlyDeliveryNoteDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'PrintOnlyDeliveryNote' | translate}}</mat-slide-toggle>
            </div>
  
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SendInvoiceOnlyToAccountingDepartment" matTooltip="{{ 'SendInvoiceOnlyToAccountingDepartmentDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SendInvoiceOnlyToAccountingDepartment' | translate}}</mat-slide-toggle>
            </div>
  
            <mat-form-field class="ProcessingSettingsCurrency" appearance="outline" matTooltip="{{ 'ProcessingSettingsCurrencyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <mat-label>{{ 'ProcessingSettingsCurrency' | translate }}</mat-label>
              <mat-select name="currency" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.ProcessingSettings.Currency">
                <mat-option *ngFor="let c of this.Currencies" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <mat-form-field class="ProcessingSettingsCurrency" appearance="outline">
              <mat-label>{{ 'DecimalPercision' | translate }}</mat-label>
              <mat-select name="DecimalPrecision" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.ProcessingSettings.DecimalPrecision">
                <mat-option *ngFor="let d of this.DecimalPrecisions" [value]="d">
                  {{d.Meaning}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <div style="width: 100%;float: left;height: 40px;">
              <div class="CheckboxProperty" style="margin-bottom: 20px;">
                <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SellThroughPartnerCompany" matTooltip="{{ 'SellingPartnerCompanyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SellingPartnerCompany' | translate}}</mat-slide-toggle>
              </div>
            </div>
  
            <div style="width: 100%;float: left;margin-bottom: 25px;" *ngIf="this.Partner.ProcessingSettings.SellThroughPartnerCompany == true;">
              <mat-form-field class="ProcessingSettingsCurrency" appearance="outline">
                <mat-label>{{ 'ChooseSellingPartnerCompany' | translate }}</mat-label>
                <mat-select name="PartnerCompany" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.ProcessingSettings.PartnerCompany">
                  <mat-option *ngFor="let c of this.Companies" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <button style="color: #fff;background: #020044;margin-top: 50px;" mat-raised-button class="SaveProcessingSettingsButton" (click)="AddUpdatePartnerProcessingSettings();">
              <i class="material-icons">save_alt</i>
              {{'SaveProcessingSettings' | translate}}
            </button>
  
          </div>
        </div>
  
      </div>
      <div class="NewProductContainerCommands">
        <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Partner.ID == null;" (click)="AddNewPartner(this.Partner);">
          <i class="material-icons">add</i>
          {{'AddNewPartner' | translate}}
        </button>
  
        <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Partner.ID?.length > 0;" (click)="UpdatePartner(this.Partner);">
          <i class="material-icons">edit</i>
          {{'ModifyPartner' | translate}}
        </button>
      </div>
    </div>
  
    <div class="PageContentTitle">
          <div class="PageContentTitleIntro">
              <i class="material-icons">perm_data_setting</i>
              <p class="PageContentTitleParagraph">{{'ProductsPriceSettings' | translate}}</p>
          </div>
  
          <div class="TitleSearchInputContainer">
            <mat-spinner *ngIf="loadingProducts" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
            <input type="text" class="TitleSearchInput" placeholder="{{'SearchProducts' | translate}}" autocomplete="off" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.productsSearchTermUpdate.next($event)">
            <i class="material-icons TitleSearchInputContainerSearchIcon" *ngIf="loadingProducts != true;">search</i>
            <i class="material-icons TitleSearchInputContainerCloseIcon" *ngIf="this.Filter.SearchTerm.length > 0;" (click)="this.Filter.SearchTerm = '';">close</i>
          </div>
  
          <div class="PageContentTitleCommands">
              <button mat-raised-button color="primary" class="TitleFilterButton" (click)="ShowFilter = !ShowFilter;">
                  {{'Filter' | translate}}
                  <i class="material-icons">filter_alt</i>
                  <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
              </button>
  
              <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="OpenNewProfitSettings();">
                  {{ 'ProfitSettings' | translate }}
                  <i class="material-icons">add</i>
              </button>
  
              <div class="ButtonFilterContainer animated fadeIn" *ngIf="ShowFilter == true;">
                 <div *ngIf="this.ShowProductsProfits != true;">
                  <i class="material-icons ButtonFilterContainerCloseIcon" (click)="ShowFilter = false;">close</i>
                  <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.FilterLoading == true;"></mat-spinner>
                  
                  <div *ngIf="this.FilterLoading != true;">
                      <div class="ButtonFilterContainerRow">
                          <div class="ButtonFilterContainerTwoThirdsColumn" style="width: 100%;">
                            <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
                              <mat-label>{{'SelectBrand' | translate}}</mat-label>
                              <input class="BrandSelect"
                                     type="text"
                                     placeholder="{{'SelectBrand' | translate}}"
                                     matInput
                                     [matAutocomplete]="auto1"
                                     [(ngModel)]="this.BrandSearchTerm"
                                     (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                                     (click)="InitializeBrands();">
                              <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
                              <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
                              <mat-autocomplete #auto1="matAutocomplete">
                                <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Filter.Brand = brand; this.Brand = brand; this.BrandSearchTerm = brand.Name; this.ProfitSettings.Brand = brand;">
                                  {{brand.Name}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </div>
                      </div>

                      <div class="ButtonFilterContainerRow">
                        <div class="ButtonFilterContainerTwoThirdsColumn" style="width: 100%;">
                          <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
                            <mat-label>{{'SearchPartners' | translate}}</mat-label>
                            <input class="BrandSelect"
                                   type="text"
                                   placeholder="{{'SearchPartners' | translate}}"
                                   matInput
                                   [matAutocomplete]="auto2"
                                   [(ngModel)]="this.PartnerSearchTerm"
                                   (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                                   (click)="InitializePartners();">
                            <i class="material-icons BrandSelectCloseIcon" *ngIf="this.PartnerSearchTerm?.length > 0;" (click)="ClearSearchPartners();">close</i>
                            <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.PartnerSearchTerm?.length > 0) != true;">search</i>
                            <mat-autocomplete #auto2="matAutocomplete">
                              <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.Partner = p; this.PartnerSearchTerm = p.Name; this.PartnersFilter.SearchTerm = p.Name;">
                                {{p.Name}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>
                    </div>

                    <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerTwoThirdsColumn" style="width: 100%;">
                        <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
                          <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
                          <input class="BrandSelect"
                                 type="text"
                                 placeholder="{{'SearchConfiguration' | translate}}"
                                 matInput
                                 (click)="InitializeImportConfigurations();"
                                 [matAutocomplete]="auto3"
                                 [(ngModel)]="this.ConfigurationTerm"
                                 (ngModelChange)="this.configSearchTermUpdate.next($event)">
                          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.ConfigurationTerm?.length > 0;" (click)="ClearSearchConfig();">close</i>
                          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.ConfigurationTerm?.length > 0) != true;">search</i>
                          <mat-autocomplete #auto3="matAutocomplete">
                            <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="SelectConfiguration(c);">
                              {{c.Name}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerTwoThirdsColumn" style="width: 100%;">
                        <div *ngIf="this.ImportConfiguration?.DiscountedGroups?.length > 0;">
                          <mat-form-field appearance="outline"class="ProductPropertyTextBox" style="margin-left: 5%;">
                            <mat-label>{{ 'SearchGroup' | translate }}</mat-label>
                            <mat-select name="SearchGroup" [compareWith]="this.parent.compareFn" [(ngModel)]="this.DiscountGroup">
                              <mat-option *ngFor="let g of this.ImportConfiguration?.DiscountedGroups" [value]="g">
                                {{g.GroupName}} ({{g.DiscountValue}}% {{'PurchaseDiscount' | translate}})
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                         </div>
                      </div>
                    </div>
  
                      <div class="ButtonFilterContainerRow" style="padding-left: 3%;height: auto;min-height: 60px;padding-top: 10px;">
                        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                          {{a.Name}}
                          <i class="material-icons ActiveFilterIcon">close</i>
                        </div>
                      </div>
  
                      <div class="ButtonFilterContainerRow" style="margin-bottom: 15px;">
                          <div class="ButtonFilterContainerOneThirdColumn">
                              <button mat-raised-button color="primary" class="ApplyFilterButton" (click)="ShowFilter = false;GetProfitSettingsFilteredByChoice();">
                                  <i class="material-icons">check</i>
                                  {{'ApplyFilter' | translate}}
                              </button>
                          </div>
                          <div class="ButtonFilterContainerTwoThirdsColumn">
  
                          </div>
                      </div>
                  </div>
                 </div>
                 <div *ngIf="this.ShowProductsProfits == true;">
                    <i class="material-icons ButtonFilterContainerCloseIcon" (click)="ShowFilter = false;">close</i>
                    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.FilterLoading == true;"></mat-spinner>

                    <div class="ButtonFilterContainerRow">
                      <mat-form-field class="BrandSelectContainer" appearance="outline" style="width: 90%;margin-left: 3.33%;">
                        <mat-label>{{'SelectBrand' | translate}}</mat-label>
                        <input class="BrandSelect"
                               type="text"
                               placeholder="{{'SelectBrand' | translate}}"
                               matInput
                               [matAutocomplete]="auto1"
                               [(ngModel)]="this.BrandSearchTerm"
                               (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                               (click)="InitializeBrands();">
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
                        <mat-autocomplete #auto1="matAutocomplete">
                          <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Filter.Brand = brand; this.Brand = brand; this.BrandSearchTerm = brand.Name; this.ProfitSettings.Brand = brand;">
                            {{brand.Name}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>

                    <div class="ButtonFilterContainerRow">
                      <mat-form-field class="BrandSelectContainer" appearance="outline" style="width: 90%;margin-left: 3.33%;">
                        <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
                        <input class="BrandSelect"
                               type="text"
                               placeholder="{{'SearchConfiguration' | translate}}"
                               matInput
                               (click)="InitializeImportConfigurations();"
                               [matAutocomplete]="auto3"
                               [(ngModel)]="this.ConfigurationTerm"
                               (ngModelChange)="this.configSearchTermUpdate.next($event)">
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.ConfigurationTerm?.length > 0;" (click)="ClearSearchConfig();">close</i>
                        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.ConfigurationTerm?.length > 0) != true;">search</i>
                        <mat-autocomplete #auto3="matAutocomplete">
                          <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="SelectConfiguration(c);">
                            {{c.Name}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>

                    <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductBoxStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductBoxStatus">
                            <mat-option *ngFor="let s of this.ProductBoxStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductBoxStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductConditionStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductConditionStatus">
                            <mat-option *ngFor="let s of this.ProductConditionStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductConditionStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                  <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductManufacturingStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductManufacturingStatus">
                            <mat-option *ngFor="let s of this.ProductManufacturingStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductManufacturingStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductVersionStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductVersionStatus">
                            <mat-option *ngFor="let s of this.ProductVersionStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductVersionStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                  <div class="ButtonFilterContainerRow">
                    <div class="ButtonFilterContainerOneThirdColumn">
                    
                    </div>
                    <div class="ButtonFilterContainerTwoThirdsColumn">
                    
                    </div>
                  </div>

                  <div class="ButtonFilterContainerRow" style="padding-left: 3%;height: auto;min-height: 60px;padding-top: 10px;">
                    <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                      {{a.Name}}
                      <i class="material-icons ActiveFilterIcon">close</i>
                    </div>
                  </div>

                  <div class="ButtonFilterContainerRow" style="margin-bottom: 15px;">
                      <div class="ButtonFilterContainerOneThirdColumn">
                          <button mat-raised-button color="primary" class="ApplyFilterButton" (click)="ShowFilter = false;GetProfitSettingsFilteredByChoice();">
                              <i class="material-icons">check</i>
                              {{'ApplyFilter' | translate}}
                          </button>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">

                      </div>
                  </div>

                 </div>
                </div>
          </div>
    </div>
  
    <div class="PageContentBody animated fadeIn">
          <div class="PageContentBodyTopCommands">

            <div class="TopCommandsChoiceContainer">
              <div class="TopCommandChip" [ngClass]="{'SelectedChip': ShowProductsProfits == false}" (click)="this.ShowProductsProfits = !this.ShowProductsProfits; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                <span>{{'ShowGeneralProfits' | translate}}</span>
                <i class="material-icons" *ngIf="ShowProductsProfits">close</i>
                <i class="material-icons" *ngIf="!ShowProductsProfits">check</i>
              </div>

              <div class="TopCommandChip" [ngClass]="{'SelectedChip': ShowProductsProfits == true}" (click)="this.ShowProductsProfits = !this.ShowProductsProfits; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                <span>{{'ShowProductsProfits' | translate}}</span>
                <i class="material-icons" *ngIf="!ShowProductsProfits">close</i>
                <i class="material-icons" *ngIf="ShowProductsProfits">check</i>
              </div>
              
              <div class="TopCommandChipDelimiter" *ngIf="ShowProductsProfits"></div>

              <div *ngIf="this.ShowProductsProfits">
                <div class="TopCommandChip" [ngClass]="{'SelectedChip': ShowStockProductsProfits == false}" (click)="this.ShowStockProductsProfits = !this.ShowStockProductsProfits; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                  <span>{{'ShowListPriceProducts' | translate}}</span>
                  <i class="material-icons" *ngIf="ShowStockProductsProfits">close</i>
                  <i class="material-icons" *ngIf="!ShowStockProductsProfits">check</i>
                </div>
                
                <div class="TopCommandChip" [ngClass]="{'SelectedChip': ShowStockProductsProfits == true}" (click)="this.ShowStockProductsProfits = !this.ShowStockProductsProfits; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                  <span>{{'ShowStockProducts' | translate}}</span>
                  <i class="material-icons" *ngIf="!ShowStockProductsProfits">close</i>
                  <i class="material-icons" *ngIf="ShowStockProductsProfits">check</i>
                </div>
              </div>

              <div class="TopLevelPaginator unSelectable" *ngIf="this.loadingGallery != true;">
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                  <i class="material-icons">chevron_left</i>
                </div>
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                  <i class="material-icons">chevron_left</i>
                </div>
    
                <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
                  <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                  <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="this.Filter.Pager.PageIndex = 1; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                </mat-form-field>
    
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1; GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                  <i class="material-icons">chevron_right</i>
                </div>
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                  <i class="material-icons">chevron_right</i>
                </div>
    
                <span class="pageInfoSpan" *ngIf="this.loadingGallery != true;">{{this.Products?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Products' | translate }} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
              </div>
    
              <button *ngIf="this.loadingGallery != true;" mat-raised-button color="primary" class="FilterResultsButton" (click)="GetProfitSettingsFilteredByChoice(this.Filter.Pager.PageIndex);">
                <i class="material-icons">check</i>
                {{'ApplyFilter' | translate}}
              </button>
            </div>
          </div>
  
          <div class="PageContentBodyElementsContainer" *ngIf="this.ShowProductsProfits != true;">
            <div class="ProfitSettingsTable">
                <div class="ProfitSettingsRow ProfitSettingsHeadder">
                  <div class="ProfitSettingsCol" style="width: 5%;">
                    <span>#</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 25%;">
                    <span>{{'ImportConfiguration' | translate}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 10%;">
                    <span>{{'DiscountGroup' | translate}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 15%;">
                    <span>{{'Client' | translate}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 15%;">
                    <span>{{'Brand' | translate}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 15%;">
                    <span>{{'Percentage' | translate}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 10%;">
                    <span>{{'Profit' | translate}}</span>
                  </div>
    
                  <div class="ProfitSettingsCol" style="width: 5%;">
                    <span>{{'Actions' | translate}}</span>
                  </div>
                </div>
      
               <div *ngIf="this.loadingGallery == false;">
                <div class="ProfitSettingsRow" *ngFor="let ps of this.ProfitSettingsList; let i=index;">
                  <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                    <span>{{i + 1}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 25%;" (click)="EditProfitSettings(ps);">
                    <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                    <span *ngIf="ps.ImportConfiguration == null;">-----</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                    <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                    <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                    <span *ngIf="ps.DiscountGroup == null;">-----</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                    <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                    <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">{{'ValidForAllPartners' | translate}}</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                    <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                    <span *ngIf="ps.Brand == null;">-----</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                    <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                    <span *ngIf="ps.Percentage == null;">-----</span>
                  </div>
      
                  <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                    <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                    <span *ngIf="ps.PercentageImpact == null;">-----</span>
                  </div>
    
                  <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                    <i class="material-icons">edit</i>
                  </div>
                </div>
               </div>

               <div *ngIf="this.loadingGallery == true;" style="margin-top: 50px;"></div>
                  <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingGallery == true;"></mat-spinner>
              </div>
          </div>

          <div class="PageContentBodyElementsContainer" *ngIf="this.ShowProductsProfits == true && this.ShowStockProductsProfits != true;">
            <div class="TaskRow TaskHeadderRow">
              <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                #
              </div>
              <div class="ProductsCol" style="width: 15%;">
                {{'Name' | translate}}
              </div>
              <div class="ProductsCol" style="width: 20%;">
                {{'Properties' | translate}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{'Brand' | translate}}
              </div>
              <div class="ProductsCol" style="width: 20%;">
                {{'PricesData' | translate}}
              </div>
              <div class="ProductsCol" style="width: 20%;text-align:center;">
                
              </div>
              <div class="ProductsCol" style="width: 10%;text-align:center;">
                {{'Actions' | translate}}
              </div>
            </div>
    
            <div *ngIf="this.loadingGallery == false;">
              <div class="ProductsContainer">
                <div class="ProductRow" *ngFor="let p of this.Products; let i=index;" [ngClass]="{'OverduePopUp': p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0 }">
                  <div class="ProductsColWarnBubble" *ngIf="p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0;">
                  </div>
                  <div style="background: #32aa3a;" class="ProductsColWarnBubble" *ngIf="!(p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0);">
                  </div>
                  <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                    {{i + 1}}
                  </div>
                  <div class="ProductsCol" style="width: 15%;padding-top: 20px;">
                    <p class="ProductsColMain" *ngIf="p.Brand != null;">
                      {{p.Brand?.Name}}
                    </p>
                    <p class="ProductsColMain">
                      <span style="font-size:15px;color: #0082e6;font-weight: 400;">{{p.Name}}</span>
                    </p>
                    <p class="ProductsColMain" *ngIf="p.PartNumber != null;">
                      <span class="ProductsColMainSpan">{{'PartNumber' | translate}}: </span>
                      {{p.PartNumber}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.Partner?.Name?.length > 0;" matTooltip="{{p.ListPriceOffers[0]?.Partner?.Name}}" matTooltipClass='neutral-tool-tip-management'>
                      <span class="ProductsColMainSpan">{{'Supplier' | translate}}: </span>
                      <span class="ListPriceOffersPartnerName">{{p.ListPriceOffers[0]?.Partner?.Name}}</span>
                    </p>
                    <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.Configuration?.Name?.length > 0;" matTooltip="{{p.ListPriceOffers[0]?.Configuration?.Name}}" matTooltipClass='neutral-tool-tip-management'>
                      <span class="ProductsColMainSpan">{{'ImportConfiguration' | translate}}: </span>
                      <span class="ListPriceOffersPartnerName">{{p.ListPriceOffers[0]?.Configuration?.Name}}</span>
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 20%;padding-top: 18px;">
                    <p class="ProductsColMain" *ngIf="p.Stats?.HSCode != null;">
                      <span class="ProductsColMainSpan">{{'HSCode' | translate}}: </span>
                      {{p.Stats?.HSCode}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.Stats?.COO != null;">
                      <span class="ProductsColMainSpan">{{'COO' | translate}}: </span>
                      {{p.Stats?.COO?.Name}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.Stats?.EAN != null;">
                      <span class="ProductsColMainSpan">{{'EAN' | translate}}: </span>
                      {{p.Stats?.EAN}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.Stats?.Weight != null;">
                      <span class="ProductsColMainSpan">{{'Weight' | translate}}: </span>
                      {{p.Stats?.Weight}} {{p.Stats?.WeightMeasurementType?.Name}}
                    </p>
                    <p class="ProductsColMain">
                      <span class="ProductsColMainSpan">{{'ProductManufacturingStatus' | translate}}: </span>
                      {{p.ManufacturingStatus?.Name}}
                    </p>
                    <p class="ProductsColMain">
                      <span class="ProductsColMainSpan">{{'ProductVersionStatus' | translate}}: </span>
                      {{p.VersionStatus?.Name}}
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 10%;padding-top: 20px;">
                    <p class="ProductsInputMain" *ngIf="p.Brand != null;">
                      {{p.Brand?.Name}}
                    </p>
                    <p class="ProductsInputMain" *ngIf="p.ListPriceOffers[0]?.ConditionStatus != null;">
                      {{p.ListPriceOffers[0]?.ConditionStatus.Name}}
                    </p>
                    <p class="ProductsInputMain" *ngIf="p.ListPriceOffers[0]?.BoxStatus != null;">
                      {{p.ListPriceOffers[0]?.BoxStatus.Name}}
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 20%;padding-top: 20px;">
                    <p class="ProductsInputMain">
                      <span *ngIf="p.ListPriceOffers[0]?.Configuration?.SellPriceCalculationType?.ID == 0;" style="float: left;margin-right: 10px;">{{'List' | translate}}: </span> 
                      <span *ngIf="p.ListPriceOffers[0]?.Configuration?.SellPriceCalculationType?.ID > 0;" style="float: left;margin-right: 10px;">{{'Purchase' | translate}}: </span>
                      <span>
                        <input (keypress)="parent.OnlyNumbers($event)" (click)="$event.target.select()" class="ProductsInput" type="text" [(ngModel)]="p.ListPriceOffers[0].ListPrice"/>
                      </span>
                      <span style="float: right;margin-right: 10px;">{{p.ListPriceOffers[0]?.Currency?.Name}}</span>
                    </p>
                    <p class="ProductsInputMain">
                      <span style="float: left;margin-right: 10px;">{{'DiscountedListPrice' | translate}}: </span> 
                      <span>
                        <input (keypress)="parent.OnlyNumbers($event)" (click)="$event.target.select()" class="ProductsInput" type="text" [(ngModel)]="p.ListPriceOffers[0].DiscountedPrice"/>
                      </span>
                      <span style="float: right;margin-right: 10px;">{{p.ListPriceOffers[0]?.Currency?.Name}}</span>
                    </p>
                    <p class="ProductsInputMain">
                      <span *ngIf="p.ListPriceOffers[0]?.Configuration?.SellPriceCalculationType?.ID == 0;" style="float: left;margin-right: 10px;">{{'CalculatedSell' | translate}}: </span> 
                      <span *ngIf="p.ListPriceOffers[0]?.Configuration?.SellPriceCalculationType?.ID > 0;" style="float: left;margin-right: 10px;">{{'FixedSell' | translate}}: </span> 
                      <span>
                        <input [ngClass]="{'underSell': p.ListPriceOffers[0]?.SellingPrice <  p.ListPriceOffers[0]?.DiscountedPrice, 'overSell' : p.ListPriceOffers[0]?.SellingPrice >  p.ListPriceOffers[0]?.DiscountedPrice }" (keypress)="parent.OnlyNumbers($event)" (click)="$event.target.select()" class="ProductsInput" type="text" [(ngModel)]="p.ListPriceOffers[0].SellingPrice"/>
                      </span>
                      <span style="float: right;margin-right: 10px;">{{p.ListPriceOffers[0]?.Currency?.Name}}</span>
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 20%;text-align:center;padding-top: 20px;">
                    <div class="StockUpdateButton" (click)="AddUpdateListPriceOffer(p.ListPriceOffers[0]);">
                      {{'Update' | translate}}
                    </div>
                  </div>
                  <div class="ProductsCol" style="width: 10%;text-align: center;padding-top: 10px;">
                    <i class="material-icons actionsArrow unSelectable" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
                    <mat-menu #menu="matMenu">
                     <button mat-menu-item class="ReceptionMenuButton">
                         <i class="material-icons">edit</i>
                         <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                     </button>
      
                     <button mat-menu-item class="ReceptionMenuButton">
                       <i class="material-icons">close</i>
                       <span>{{ 'Delete' | translate }}</span>
                     </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          
            <div *ngIf="this.loadingGallery == true;" style="margin-top: 50px;">
              <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingGallery == true;"></mat-spinner>
            </div>
          </div>

          <div class="PageContentBodyElementsContainer" *ngIf="this.ShowProductsProfits == true && this.ShowStockProductsProfits == true;">
            <div class="TaskRow TaskHeadderRow">
              <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                #
              </div>
              <div class="ProductsCol" style="width: 15%;">
                {{'Name' | translate}}
              </div>
              <div class="ProductsCol" style="width: 20%;">
                {{'Properties' | translate}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{'Brand' | translate}}
              </div>
              <div class="ProductsCol" style="width: 20%;">
                {{'PricesData' | translate}}
              </div>
              <div class="ProductsCol" style="width: 20%;text-align:center;">
                
              </div>
              <div class="ProductsCol" style="width: 10%;text-align:center;">
                {{'Actions' | translate}}
              </div>
            </div>
    
            <div *ngIf="this.loadingGallery == false;">
              <div class="ProductsContainer">
                <div class="ProductRow" *ngFor="let p of this.Products; let i=index;" [ngClass]="{'OverduePopUp': p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0 }">
                  <div class="ProductsColWarnBubble" *ngIf="p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0;">
                  </div>
                  <div style="background: #32aa3a;" class="ProductsColWarnBubble" *ngIf="!(p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0);">
                  </div>
                  <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                    {{i + 1}}
                  </div>
                  <div class="ProductsCol" style="width: 15%;padding-top: 20px;">
                    <p class="ProductsColMain" *ngIf="p.Brand != null;">
                      {{p.Brand?.Name}}
                    </p>
                    <p class="ProductsColMain">
                      <span style="font-size:15px;color: #0082e6;font-weight: 400;">{{p.Name}}</span>
                    </p>
                    <p class="ProductsColMain" *ngIf="p.PartNumber != null;">
                      <span class="ProductsColMainSpan">{{'PartNumber' | translate}}: </span>
                      {{p.PartNumber}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.Partner?.Name?.length > 0;" matTooltip="{{p.ListPriceOffers[0]?.Partner?.Name}}" matTooltipClass='neutral-tool-tip-management'>
                      <span class="ProductsColMainSpan">{{'Supplier' | translate}}: </span>
                      <span class="ListPriceOffersPartnerName">{{p.ListPriceOffers[0]?.Partner?.Name}}</span>
                    </p>
                    <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.Configuration?.Name?.length > 0;" matTooltip="{{p.ListPriceOffers[0]?.Configuration?.Name}}" matTooltipClass='neutral-tool-tip-management'>
                      <span class="ProductsColMainSpan">{{'ImportConfiguration' | translate}}: </span>
                      <span class="ListPriceOffersPartnerName">{{p.ListPriceOffers[0]?.Configuration?.Name}}</span>
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 20%;padding-top: 18px;">
                    <p class="ProductsColMain" *ngIf="p.Stats?.HSCode != null;">
                      <span class="ProductsColMainSpan">{{'HSCode' | translate}}: </span>
                      {{p.Stats?.HSCode}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.Stats?.COO != null;">
                      <span class="ProductsColMainSpan">{{'COO' | translate}}: </span>
                      {{p.Stats?.COO?.Name}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.Stats?.EAN != null;">
                      <span class="ProductsColMainSpan">{{'EAN' | translate}}: </span>
                      {{p.Stats?.EAN}}
                    </p>
                    <p class="ProductsColMain" *ngIf="p.Stats?.Weight != null;">
                      <span class="ProductsColMainSpan">{{'Weight' | translate}}: </span>
                      {{p.Stats?.Weight}} {{p.Stats?.WeightMeasurementType?.Name}}
                    </p>
                    <p class="ProductsColMain">
                      <span class="ProductsColMainSpan">{{'ProductManufacturingStatus' | translate}}: </span>
                      {{p.ManufacturingStatus?.Name}}
                    </p>
                    <p class="ProductsColMain">
                      <span class="ProductsColMainSpan">{{'ProductVersionStatus' | translate}}: </span>
                      {{p.VersionStatus?.Name}}
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 10%;padding-top: 20px;">
                    <p class="ProductsInputMain" *ngIf="p.Brand != null;">
                      {{p.Brand?.Name}}
                    </p>
                    <p class="ProductsInputMain" *ngIf="p.ListPriceOffers[0]?.ConditionStatus != null;">
                      {{p.ListPriceOffers[0]?.ConditionStatus.Name}}
                    </p>
                    <p class="ProductsInputMain" *ngIf="p.ListPriceOffers[0]?.BoxStatus != null;">
                      {{p.ListPriceOffers[0]?.BoxStatus.Name}}
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 20%;padding-top: 20px;">
                    <p class="ProductsInputMain">
                      <span style="float: left;margin-right: 10px;">{{'List' | translate}}: </span> 
                      <span>
                        <input (keypress)="parent.OnlyNumbers($event)" (click)="$event.target.select()" class="ProductsInput" type="text" [(ngModel)]="p.ListPriceOffers[0].ListPrice"/>
                      </span>
                      <span style="float: right;margin-right: 10px;">{{p.ListPriceOffers[0]?.Currency?.Name}}</span>
                    </p>
                    <p class="ProductsInputMain">
                      <span style="float: left;margin-right: 10px;">{{'DiscountedListPrice' | translate}}: </span> 
                      <span>
                        <input (keypress)="parent.OnlyNumbers($event)" (click)="$event.target.select()" class="ProductsInput" type="text" [(ngModel)]="p.ListPriceOffers[0].DiscountedPrice"/>
                      </span>
                      <span style="float: right;margin-right: 10px;">{{p.ListPriceOffers[0]?.Currency?.Name}}</span>
                    </p>
                    <p class="ProductsInputMain">
                      <span style="float: left;margin-right: 10px;">{{'Sell' | translate}}: </span> 
                      <span>
                        <input [ngClass]="{'underSell': p.ListPriceOffers[0]?.SellingPrice <  p.ListPriceOffers[0]?.DiscountedPrice, 'overSell' : p.ListPriceOffers[0]?.SellingPrice >  p.ListPriceOffers[0]?.DiscountedPrice }" (keypress)="parent.OnlyNumbers($event)" (click)="$event.target.select()" class="ProductsInput" type="text" [(ngModel)]="p.ListPriceOffers[0].SellingPrice"/>
                      </span>
                      <span style="float: right;margin-right: 10px;">{{p.ListPriceOffers[0]?.Currency?.Name}}</span>
                    </p>
                  </div>
                  <div class="ProductsCol" style="width: 20%;text-align:center;padding-top: 20px;">
                    <div class="StockUpdateButton" (click)="AddUpdateListPriceOffer(p.ListPriceOffers[0]);">
                      {{'Update' | translate}}
                    </div>
                  </div>
                  <div class="ProductsCol" style="width: 10%;text-align: center;padding-top: 10px;">
                    <i class="material-icons actionsArrow unSelectable" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
                    <mat-menu #menu="matMenu">
                     <button mat-menu-item class="ReceptionMenuButton">
                         <i class="material-icons">edit</i>
                         <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                     </button>
      
                     <button mat-menu-item class="ReceptionMenuButton">
                       <i class="material-icons">close</i>
                       <span>{{ 'Delete' | translate }}</span>
                     </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          
            <div *ngIf="this.loadingGallery == true;" style="margin-top: 50px;">
              <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.loadingGallery == true;"></mat-spinner>
            </div>
          </div>
    </div> 
    </div>